<template>
  <div
    :style="{ transform: 'scale(' + scal + ')' }"
    class="honorary-certificate"
    id="honorary-certificate"
  >
    <!-- <mod-title class="text-mod" title="相关获奖" enTitle="AWARDS" :sentenceShow="true" sentenceText="" /> -->
    <div class="new-title">
      {{
        $theme
          ? "以国际物联网前瞻架构'多模异构物联网络技术'获国内外多项发明金奖"
          : "Won multiple invention gold awards at home and abroad with the international IoT forward-looking architecture 'Multi-mode heterogeneous IoT network technology'"
      }}
    </div>
    <div class="list" :class="{ 'eng-list': !$theme }">
      <!-- <img class="move-left" src="/image/brand-honor/move-left.png" @click="move('left')" /> -->

      <div class="img move-left">
        <div class="quan" @click="move('left')">
          <div class="con">
            <i class="el-icon-back"></i>
            <i class="el-icon-back"></i>
          </div>
        </div>
      </div>
      <div class="img move-right">
        <div class="quan" @click="move('right')">
          <div class="con">
            <i class="el-icon-back"></i>
            <i class="el-icon-back"></i>
          </div>
        </div>
      </div>
      <!-- <img class="move-right img" src="/image/brand-honor/move-left.png" @click="move('right')" /> -->
      <div class="item left">
        <div class="no">0{{ index.left }}</div>
        <div class="blue-block"></div>
        <div class="title">
          {{
            $theme ? list[index.left - 1].title : list[index.left - 1].titleEng
          }}
        </div>
        <div class="content" :class="{ 'con-3': list[index.left - 1].id == 3 }">
          {{
            $theme
              ? list[index.left - 1].content
              : list[index.left - 1].contentEng
          }}
        </div>
      </div>
      <div class="item center">
        <img
          :src="
            require(`@/assets/img/brand-honor/awards/${
              list[index.center - 1].url
            }.png`)
          "
          :class="{ 'img-large': index.center === 2 }"
        />
        <div class="no">0{{ index.center }}</div>
        <div class="point-deco-end deco"></div>
        <div class="main">
          <div class="title">
            {{
              $theme
                ? list[index.center - 1].title
                : list[index.center - 1].titleEng
            }}
          </div>
          <div class="white-block"></div>
          <div
            class="content"
            v-html="
              $theme
                ? list[index.center - 1].content
                : list[index.center - 1].contentEng
            "
          ></div>
        </div>
      </div>
      <div class="item right">
        <div class="no">0{{ index.right }}</div>
        <div class="blue-block"></div>
        <div class="title">
          {{
            $theme
              ? list[index.right - 1].title
              : list[index.right - 1].titleEng
          }}
        </div>
        <div
          class="content"
          :class="{ 'con-3': list[index.right - 1].id == 3 }"
        >
          {{
            $theme
              ? list[index.right - 1].content
              : list[index.right - 1].contentEng
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PropertyRights",
  components: {},
  data() {
    return {
      index: {
        left: 6,
        center: 1,
        right: 2,
      },
      list: [
        {
          id: 1,
          title: "“创客中国”全国50强",
          titleEng: '"Maker China" national top 50',
          contentEng:
            'In the 8th National Competition of "Maker China" SME Innovation and Entrepreneurship Competition, China entropy won the national Top 50 and the first prize of "Maker China" Hebei Innovation and Entrepreneurship Competition with its independent innovation technology.',
          content:
            "在第八届“创客中国”中小企业创新创业大赛全国赛中，汉熵凭借自主创新技术荣获全国50强，“创客中国”河北省创新创业大赛一等奖。",
          url: "创客中国",
        },
        {
          id: 2,
          title: "2023年ITEC全球创业赛一等奖",
          titleEng: "2023 ITEC Global Entrepreneurship Competition first prize",
          contentEng:
            'In December 2023, China entropy won the first prize in the ITEC Global Entrepreneurship Competition with the project of "National First Artificial Intelligence Industrial Internet of Things based on multi-mode heterogeneous bearer Network and edge computing".',
          content:
            "2023年12月，汉熵凭借“基于多模异构承载网络及边缘计算的人工智能工业物联网”项目荣获ITEC全球创业赛一等奖。",
          url: "ITEC",
        },
        {
          id: 3,
          title: "多模异构IOT技术获得《科学技术成果证书》",
          titleEng:
            'Multi-mode heterogeneous IoT technology received the highest evaluation of "international leading"',
          contentEng:
            "In the evaluation of scientific and technological achievements organized by the National Industrial Information Security Development Research Center in May 2024, the core technology of multi-mode heterogeneous Internet of Things was recognized by a number of academicians and industry experts, and was assessed as an international leader by the Ministry of Industry and Information Technology.",
          content:
            "在2024年5月由国家工业信息安全发展研究中心组织的科技成果评价中，多模异构物联网核心技术得到多名院士及行业专家认可。",
          url: "多模异构",
        },
        {
          id: 4,
          title: "日内瓦国际发明奖",
          titleEng: "Geneva International Invention Award",
          contentEng:
            'At the Geneva International Invention Exhibition 2022, one of the world\'s three major invention exhibitions, China entropy won the gold medal of invention patent with its self-developed patent "Multimode Heterogeneous IoT Networks"!',
          content:
            "在世界三大发明展之一的2022年日内瓦国际发明展（International Exhibition of Inventions of Geneva）上，汉熵凭借自研专利“Multimode Heterogeneous IoT Networks（多模异构IoT网络）” 斩获发明专利金奖！",
          url: "日内瓦国际发明奖_金奖",
        },
        {
          id: 5,
          title: "2021年物联网示范项目",
          titleEng: "2021 IoT demonstration project",
          contentEng:
            'China entropy\'s "Intelligent Forest Fire Protection Project based on Multi-mode heterogeneous bearer Network and edge Computing" was awarded as the IoT demonstration project of the Ministry of Industry and Information Technology.',
          content:
            "汉熵的“基于多模异构承载网络及边缘计算的智慧森林消防项目”被评为国家工信部物联网示范项目。",
          url: "物联网示范项目公示",
        },
        {
          id: 6,
          title: "国家发明创业奖",
          titleEng: "National Invention and Entrepreneurship Award",
          contentEng:
            'With the project of "Artificial Intelligence Industrial Internet of Things Technology and Application based on Multi-mode heterogeneous Bearer Network and Edge Computing", China entropy won the first prize of the "Invention Enterprise Award of China Invention Association" for its outstanding innovation ability.',
          content:
            "汉熵凭借“基于多模异构承载网络及边缘计算的人工智能工业物联网技术及应用”项目，以突出的创新能力荣获“中国发明协会发明创业奖”一等奖。",
          url: "发明创业奖-创新奖_一等奖",
        },
      ],
      scal: 1,
    };
  },
  methods: {
    move(direction) {
      const { index } = this;
      const { left, center, right } = index;
      if ("right" === direction) {
        if (right == 6) {
          index.left = 5;
          index.center = 6;
          index.right = 1;
        } else if (right == 1) {
          index.left = 6;
          index.center = 1;
          index.right = 2;
        } else if (right == 2) {
          index.left = 1;
          index.center = 2;
          index.right = 3;
        } else {
          index.left = left + 1;
          index.center = center + 1;
          index.right = right + 1;
        }
      } else {
        if (left == 1) {
          index.left = 6;
          index.center = 1;
          index.right = 2;
        } else if (left == 6) {
          index.left = 5;
          index.center = 6;
          index.right = 1;
        } else if (left == 5) {
          index.left = 4;
          index.center = 5;
          index.right = 6;
        } else {
          index.left = left - 1;
          index.center = center - 1;
          index.right = right - 1;
        }
      }
    },
  },
  mounted() {
    var element = document.body.clientWidth;
    // this.scal = element/1920
    // console.log(this.scal);
  },
};
</script>

<style lang="scss" scoped>
@import "./Index.scss";
</style>
